import React from 'react'
import SupplierSignUp from '../../Components/Supplier/SupplierSignUp'
import Header from '../../Components/LoginFloder/Header'
const SupplierPage = () => {
  return (
    <div>
        <Header />
        <SupplierSignUp />
    </div>
  )
}

export default SupplierPage